import type { AppRouteModule } from '/@/router/types'

import { LAYOUT } from '/@/router/constant'
import { t } from '/@/hooks/web/useI18n'

const monitor: AppRouteModule = {
    path: '/monitor',
    name: 'Monitor',
    component: LAYOUT,
    redirect: '/monitor/server',
    meta: {
        orderNo: 2002,
        icon: 'tabler:heart-rate-monitor',
        title: t('routes.demo.monitor.moduleName'),
    },
    children: [
        {
            path: 'user',
            name: 'UserMonitor',
            meta: {
                title: t('routes.demo.monitor.user'),
                icon: 'mdi:user-group',
            },
            component: () => import('/@/views/demo/monitor/server/index.vue'),
        },
        {
            path: 'server',
            name: 'ServerMonitor',
            meta: {
                title: t('routes.demo.monitor.server'),
                icon: 'carbon:cloud-lightning',
            },
            component: () => import('/@/views/demo/monitor/server/index.vue'),
        },
        {
            path: 'sql',
            name: 'SqlMonitor',
            meta: {
                title: t('routes.demo.monitor.sql'),
                icon: 'mdi:sql-query',
            },
            component: () => import('/@/views/demo/monitor/sql/index.vue'),
        },
        {
            path: 'trace',
            name: 'TraceMonitor',
            meta: {
                title: t('routes.demo.monitor.trace'),
                icon: 'icon-park-outline:trace',
            },
            component: () => import('/@/views/demo/monitor/trace/index.vue'),
        },
        {
            path: 'schedule',
            name: 'ScheduleManagement',
            meta: {
                title: t('routes.demo.monitor.schedule'),
                icon: 'ic:outline-access-time',
            },
            component: () => import('/@/views/demo/monitor/schedule/index.vue'),
        },
        {
            path: 'log',
            name: 'LogMonitor',
            component: LAYOUT,
            redirect: '/monitor/log/login',
            meta: {
                title: t('routes.demo.monitor.log.moduleName'),
                icon: 'icon-park-outline:log',
            },
            children: [
                {
                    path: 'login',
                    name: 'LogLoginMonitor',
                    meta: {
                        title: t('routes.demo.monitor.log.login'),
                        icon: 'mdi:login-variant',
                    },
                    component: () => import('/@/views/demo/monitor/log/login/index.vue'),
                },
                {
                    path: 'operate',
                    name: 'LogOperateMonitor',
                    meta: {
                        title: t('routes.demo.monitor.log.operate'),
                        icon: 'carbon:operations-record',
                    },
                    component: () => import('/@/views/demo/monitor/log/operate/index.vue'),
                },
            ],
        },
    ],
}

export default monitor
